import React from 'react'
import { useNavigate } from 'react-router-dom';
import { FaHouseDamage } from "react-icons/fa";

function FeaturedProp() {

  const navigate = useNavigate();

  return (
    <div className='bg-slate-100 px-5 w-[700px] h-[400px] shadow-lg hover:shadow-xl flex flex-col gap-20 justify-center items-center gap-2'>
      <div><h1 className='text-[20px] font-bold text-gray-600'>FEATURED PROPERTIES</h1></div>
      <div onClick={()=>navigate('/featuredproperties')} className='flex flex-col gap-2 justify-center px-2 items-center cursor-pointer'>
        <FaHouseDamage className='text-[#b507cc] text-[50px] hover:text-[#bb53c9]' />
        <p className='text-[15px] font-bold text-gray-700 text-center'>Featured Property</p>
      </div>
    </div>
  )
}

export default FeaturedProp
